export const constructionConstants = {
  // GET_LOGIN_INFO: 取得建案登入資訊
  GET_LOGIN_INFO_REQUEST: "CONSTRUCTION_GET_LOGIN_INFO_REQUEST",
  GET_LOGIN_INFO_SUCCESS: "CONSTRUCTION_GET_LOGIN_INFO_SUCCESS",
  GET_LOGIN_INFO_FAILURE: "CONSTRUCTION_GET_LOGIN_INFO_FAILURE",

  // GET_EVENTS: 取得建案事件資訊
  GET_EVENTS_REQUEST: "CONSTRUCTION_GET_EVENTS_REQUEST",
  GET_EVENTS_SUCCESS: "CONSTRUCTION_GET_EVENTS_SUCCESS",
  GET_EVENTS_FAILURE: "CONSTRUCTION_GET_EVENTS_FAILURE",
  RESET_GET_EVENTS_SUCCESS: "CONSTRUCTION_RESET_GET_EVENTS_SUCCESS",

  // SEARCH_TARGET: 搜尋建案實體資訊
  SEARCH_TARGET_REQUEST: "CONSTRUCTION_SEARCH_TARGET_REQUEST",
  SEARCH_TARGET_SUCCESS: "CONSTRUCTION_SEARCH_TARGET_SUCCESS",
  SEARCH_TARGET_FAILURE: "CONSTRUCTION_SEARCH_TARGET_FAILURE",
  RESET_SEARCH_TARGET_SUCCESS: "CONSTRUCTION_RESET_SEARCH_TARGET_SUCCESS",

  // GET_SUMMARIES: 取得建案摘要資訊
  GET_SUMMARIES_REQUEST: "CONSTRUCTION_GET_SUMMARIES_REQUEST",
  GET_SUMMARIES_SUCCESS: "CONSTRUCTION_GET_SUMMARIES_SUCCESS",
  GET_SUMMARIES_FAILURE: "CONSTRUCTION_GET_SUMMARIES_FAILURE",
  RESET_SUMMARIES_SUCCESS: "CONSTRUCTION_RESET_SUMMARIES_SUCCESS",

  // REFRESH_SUMMARIES: 刷新建案摘要資訊
  REFRESH_SUMMARIES_SUCCESS: "CONSTRUCTION_REFRESH_SUMMARIES_SUCCESS",
  REFRESH_SUMMARIES_FAILURE: "CONSTRUCTION_REFRESH_SUMMARIES_FAILURE",

  // SETTING: 設定建案資訊
  SETTING_REQUEST: "CONSTRUCTION_SETTING_REQUEST",
  SETTING_SUCCESS: "CONSTRUCTION_SETTING_SUCCESS",
  SETTING_FAILURE: "CONSTRUCTION_SETTING_FAILURE",
  RESET_SETTING_SUCCESS: "CONSTRUCTION_RESET_SETTING_SUCCESS",

  // GET: 取得建案資訊
  GET_EDIT_REQUEST: "CONSTRUCTION_GET_EDIT_REQUEST",
  GET_EDIT_SUCCESS: "CONSTRUCTION_GET_EDIT_SUCCESS",
  GET_EDIT_FAILURE: "CONSTRUCTION_GET_EDIT_FAILURE",
  RESET_GET_EDIT_SUCCESS: "CONSTRUCTION_RESET_GET_EDIT_SUCCESS",

  // GET: 取得建案資訊
  GET_PAYMENT_METHOD_LIST_REQUEST: "CONSTRUCTION_GET_PAYMENT_METHOD_LIST_REQUEST",
  GET_PAYMENT_METHOD_LIST_SUCCESS: "CONSTRUCTION_GET_PAYMENT_METHOD_LIST_SUCCESS",
  GET_PAYMENT_METHOD_LIST_FAILURE: "CONSTRUCTION_GET_PAYMENT_METHOD_LIST_FAILURE",
  RESET_GET_PAYMENT_METHOD_LIST_SUCCESS: "CONSTRUCTION_RESET_GET_PAYMENT_METHOD_LIST_SUCCESS",

  // GET_PARKING_SPACE_PATTERN_LIST: 取得車位格局清單
  GET_PARKING_SPACE_PATTERN_LIST_REQUEST: "CONSTRUCTION_GET_PARKING_SPACE_PATTERN_LIST_REQUEST",
  GET_PARKING_SPACE_PATTERN_LIST_SUCCESS: "CONSTRUCTION_GET_PARKING_SPACE_PATTERN_LIST_SUCCESS",
  GET_PARKING_SPACE_PATTERN_LIST_FAILURE: "CONSTRUCTION_GET_PARKING_SPACE_PATTERN_LIST_FAILURE",
  RESET_GET_PARKING_SPACE_PATTERN_LIST_SUCCESS: "CONSTRUCTION_RESET_GET_PARKING_SPACE_PATTERN_LIST_SUCCESS",

  // GET_HOUSEHOLD_META: 取得建案戶別資訊
  GET_HOUSEHOLD_META_REQUEST: "CONSTRUCTION_GET_HOUSEHOLD_META_REQUEST",
  GET_HOUSEHOLD_META_SUCCESS: "CONSTRUCTION_GET_HOUSEHOLD_META_SUCCESS",
  GET_HOUSEHOLD_META_FAILURE: "CONSTRUCTION_GET_HOUSEHOLD_META_FAILURE",
  RESET_HOUSEHOLD_META_SUCCESS: "CONSTRUCTION_RESET_HOUSEHOLD_META_SUCCESS",

  // GET_STORE_AREA_LIST: 取得放置位置清單
  GET_STORE_AREA_LIST_REQUEST: "CONSTRUCTION_GET_STORE_AREA_LIST_REQUEST",
  GET_STORE_AREA_LIST_SUCCESS: "CONSTRUCTION_GET_STORE_AREA_LIST_SUCCESS",
  GET_STORE_AREA_LIST_FAILURE: "CONSTRUCTION_GET_STORE_AREA_LIST_FAILURE",
  RESET_STORE_AREA_LIST_SUCCESS: "CONSTRUCTION_RESET_STORE_AREA_LIST_SUCCESS",

  // GET_USER_LIST: 取得建案使用者清單
  GET_USER_LIST_REQUEST: "CONSTRUCTION_GET_USER_LIST_REQUEST",
  GET_USER_LIST_SUCCESS: "CONSTRUCTION_GET_USER_LIST_SUCCESS",
  GET_USER_LIST_FAILURE: "CONSTRUCTION_GET_USER_LIST_FAILURE",
  RESET_USER_LIST_SUCCESS: "CONSTRUCTION_RESET_USER_LIST_SUCCESS",

  // GET_PARKING_SPACE_LIST: 取得建案車位清單
  GET_PARKING_SPACE_LIST_REQUEST: "CONSTRUCTION_GET_PARKING_SPACE_LIST_REQUEST",
  GET_PARKING_SPACE_LIST_SUCCESS: "CONSTRUCTION_GET_PARKING_SPACE_LIST_SUCCESS",
  GET_PARKING_SPACE_LIST_FAILURE: "CONSTRUCTION_GET_PARKING_SPACE_LIST_FAILURE",
  RESET_PARKING_SPACE_LIST_SUCCESS: "CONSTRUCTION_RESET_PARKING_SPACE_LIST_SUCCESS"
};
